<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :is_create_screen="is_create"
    :save_btn_loading="save_btn_loading"
    :header_options="isEditMode ? [
      { description: 'Delete', icon: 'bin-delete', show: !is_create && isEditMode, delete_btn_loading: delete_btn_loading },
    ] : false"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    :hide_subpage_header="step_card ? true : false"
    @headerBack="$router.push({
      name: `${location}WorkPackage${step_type}Steps`,
      params: { nav_back: $route.params.nav_back } ,
    })"
    @headerCancel="$router.push({
      name: `${location}WorkPackage${step_type}Steps`,
      params: { nav_back: $route.params.nav_back },
    })"
    @headerSave="
      save_btn_loading = true,
      backlog
        ? createUObject({
            url: getStepUrl(step_type, '').concat([{ showWithEntitiesNormalized: '' }]),
            u_object: new_step
          }).then(() => {
            save_btn_loading = false,
              $router.push({
                name: `${location}WorkPackage${step_type}Steps`,
                params: { nav_back: $route.params.nav_back },
              })
          })
        : requestSnackbarCreate({
          url: [
            { projects: project_id },
            { trains: train_id },
            { taktareas: taktarea_id },
            { twaggons: twaggon_id },
            { tworkpackages: workpackage_id },
            { [`t${step_type.toLowerCase()}steps`]: '' },
            { showWithEntitiesNormalized: '' }
          ],
          u_object: new_step,
          selector: 'parent'
        }).then((payload) => {
          createUObject(payload).then(() => {
            save_btn_loading = false,
              $router.push({
                name: `${location}WorkPackage${step_type}Steps`,
                params: { nav_back: $route.params.nav_back },
              })
          })
        })"
    @clickHeaderDelete="
      delete_btn_loading = true,
      backlog
        ? deleteUObject({
            url: getStepUrl(step_type, step.id)
          }).then(() => {
            delete_btn_loading = false,
              $router.push({
                name: `${location}WorkPackage${step_type}Steps`,
                params: { nav_back: $route.params.nav_back },
              })
          })
        : requestSnackbarDelete({
            url: [
              { projects: project_id },
              { trains: train_id },
              { taktareas: taktarea_id },
              { twaggons: twaggon_id },
              { tworkpackages: workpackage_id },
              { [`t${step_type.toLowerCase()}steps`]: step.id },
            ],
            selector: 'parent',
            limit_selector: true
          }).then((payload) => {
            deleteUObject(payload).then(() => {
              delete_btn_loading = false,
                $router.push({
                  name: `${location}WorkPackage${step_type}Steps`,
                  params: { nav_back: $route.params.nav_back }
                })
            })
          })"
  >
    <template #dialog>
      <transition name="dialog_slide"
        v-if="$route.name.includes('Materials') || $route.name.includes('MaterialEditor')">
        <StandardDialogFullScreen header_max_height="80" :overflow_auto="true">
          <template #header-text>
            <div style="display: flex; grid-gap: 3px;">
              <TText :value="$route.params.template_type[0].toUpperCase() + $route.params.template_type.substring(1)" />
              <div> </div>
              <TText value="Materials" />
            </div>
          </template>
          <template #header-close>
            <v-btn @click="$router.push({ name: `${location}WorkPackage${step_type}StepsDetails`, params: { nav_back: $route.params.nav_back }, })">close</v-btn>
          </template>
          <template #content>
            <div style="display: flex; grid-gap: 8px;" class="color-4">
              <ButtonOutlined value="Custom" icon="person" width="120"
                :is_disabled="$route.params.template_type === 'custom'"
                :color="$route.params.template_type === 'custom' ? 'green' : ''"
                @buttonClicked="$router.push({ name: 'TaktPlanWorkPackageMaterialStepMaterials', params: { template_type: 'custom', nav_back: $route.params.nav_back, mfolder: 'last-updated' } })" />
              <ButtonOutlined value="Company" icon="company" width="120"
                :is_disabled="!hasBusiness || $route.params.template_type === 'company'"
                :color="$route.params.template_type === 'company' ? 'green' : ''"
                @buttonClicked="$router.push({ name: 'TaktPlanWorkPackageMaterialStepMaterials', params: { template_type: 'company', nav_back: $route.params.nav_back } })" />
              <ButtonOutlined value="Community" icon="persons-two" width="120"
                :is_disabled="$route.params.template_type === 'community'"
                :color="$route.params.template_type === 'community' ? 'green' : ''"
                @buttonClicked="$router.push({ name: 'TaktPlanWorkPackageMaterialStepMaterials', params: { template_type: 'community', nav_back: $route.params.nav_back } })" />
              <!-- <ButtonOutlined
               :style="`background-color: ${workpackage_bg_hex};`" width="120" icon="pencil" text="New Material"
               :color="workpackage_fg_hex"
               @buttonClicked="$router.push({ name: 'TaktPlanWorkPackageMaterialStepMaterialEditor', params: { material_id: 'create', template_type: 'custom', nav_back: $route.params.nav_back } })" /> -->

            </div>
            <router-view style="z-index: 40" />
          </template>
        </StandardDialogFullScreen>
      </transition>
    </template>
    <template #header-rightside>
      <!-- CHECK STEP -->
      <RadialCheckbox v-if="!is_create" :readonly="location.includes('HistProjectTaktPlan')" :id="step.id"
        :is_checked="step.done || step.status === 'done'" large :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex" style="margin: 0px 8px;" @setActive="updateUObject({
          url: getStepUrl(step_type, step.id),
          update: {
            [step_type === 'Material' ? 'status' : 'done']: step_type === 'Material' ? (step.status === 'done' ? 'open' : 'done') : !step.done
          }
        }),
          location === 'ProjectWallet' ?
            updateStepCardStatus({
              project_id: project_id,
              step_id: step.id,
              step_type: step_type.toLowerCase(),
              done: step.done,
              offset: step_card ? false : step.offset
              /* offset: step_card.offset,
              wallet_column: wallet_column, */
            }).then(() => {
              increaseUpdateKeyStepCard();
            })
            : ''
        " />
    </template>
    <template #body>
      <LabelOutlined v-if="!is_create"
        label="Status"
        :background_color="workpackage_bg_hex" :dark="is_light_mode(workpackage_fg_hex)">
        <template #content>
          <div class="work-package-step-detail-status-container">
            <ButtonOutlined class="work-package-step-detail-flex-grow"
              :style="`background-color: ${step.done || step.status === 'done' ? workpackage_bg_hex : workpackage_fg_hex};`"
              icon="checkbox-radial-empty" text="Open"
              :color="step.done || step.status === 'done' ? workpackage_fg_hex : workpackage_bg_hex" @buttonClicked="updateUObject({
                url: getStepUrl(step_type, step.id),
                update: {
                  [step_type === 'Material' ? 'status' : 'done']: step_type === 'Material' ? 'open' : false
                }
              }),
                location === 'ProjectWallet' ?
                  updateStepCardStatus({
                    project_id: project_id,
                    step_id: step.id,
                    step_type: step_type.toLowerCase(),
                    done: false,
                    offset: step_card ? false : step.offset
                    /* offset: step_card.offset,
                    wallet_column: wallet_column, */
                  }).then(() => {
                    increaseUpdateKeyStepCard();
                  })
                  : ''
              " />
            <ButtonOutlined class="work-package-step-detail-flex-grow"
              :style="`background-color: ${step.done || step.status === 'done' ? workpackage_fg_hex : workpackage_bg_hex};`"
              icon="checkbox-radial-filled" text="Done"
              :color="step.done || step.status === 'done' ? workpackage_bg_hex : workpackage_fg_hex" @buttonClicked="updateUObject({
                url: getStepUrl(step_type, step.id),
                update: {
                  [step_type === 'Material' ? 'status' : 'done']: step_type === 'Material' ? 'done' : true
                }
              }),
                location === 'ProjectWallet' ?
                  updateStepCardStatus({
                    project_id: project_id,
                    step_id: step.id,
                    step_type: step_type.toLowerCase(),
                    done: true,
                    offset: step_card ? false : step.offset
                    /* offset: step_card.offset,
                    wallet_column: wallet_column, */
                  }).then(() => {
                    increaseUpdateKeyStepCard();
                  })
                  : ''
              " />
          </div>
        </template>
      </LabelOutlined>
      <TextArea :value="step.text" :label="$t('WorkpackageRework.Steps.Description')"
        :placeholder="`Describe the ${$t(`WorkpackageRework.Steps.Types.${step_type}`) + '.' + $t(`WorkpackageRework.Steps.step`)}...`"
        :max_char_count="isEditMode ? 300 : ''"
        resize
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id })"
        @change="updateStepValue(step_type, step.id, 'text', $event)" />
      <!-- requestMaterials($event)  removed from change-->

      <!-- Work Step Specific -->
      <template v-if="step_type === 'Work'">
        <ModularEquation :description="'Time Effort'" :id="'Time Effort'" :elements="[
          { label: 'Value', id: 'Value', /*width: 85,*/ value: step.performance_value, is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id }), input_type: 'number' },
          { operator: 'mh /' },
          { label: 'Reference Unit', id: 'Reference Unit', width: 125, value: $store.state.Ultra.expense_units.find(unit => unit.value === step.mass_relation), is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id }), select: { options: $store.state.Ultra.expense_units } },
        ]" :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
          @changeValue="updateStepValue(step_type, step.id, 'performance_value', parseFloat($event))"
          @changeReferenceUnit="updateStepValue(step_type, step.id, 'mass_relation', $event)" />
      </template>

      <!-- Material Step Specific -->
      <template v-if="step_type === 'Material'">
        <ModularEquation :description="'Material Conversion'" :id="'Material Conversion'" :elements="[
          { label: 'Factor', id: 'Factor', /*width: 85,*/ value: step.conversion_factor, is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id }), input_type: 'number' },
          { label: 'Unit', id: 'Unit', width: 100, value: $store.state.Ultra.conversion_units.find(unit => unit.value === step.conversion_unit), is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id }), select: { options: $store.state.Ultra.conversion_units } },
          { operator: '/' },
          { label: 'Reference Unit', id: 'Reference Unit', width: 105, value: $store.state.Ultra.expense_units.find(unit => unit.value === step.mass_relation), is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id }), select: { options: $store.state.Ultra.expense_units } },
        ]" :is_disabled="[false, true,]" :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
          @changeFactor="updateStepValue(step_type, step.id, 'conversion_factor', parseFloat($event))"
          @changeUnit="updateStepValue(step_type, step.id, 'conversion_unit', $event)"
          @changeReferenceUnit="updateStepValue(step_type, step.id, 'mass_relation', $event)" />

        <DropDownOutlinedFlat :label="'WorkstepLink'" :options="workstep_link_selection"
          :value="workstep_link"
          :is_disabled="!(isEditMode || is_create) || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id })"
          :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
          @change="changeWorkStepLink(parseInt($event))" @click.native="(isEditMode || is_create) ?
        loadSteps()
        :
        workstep_link.value !== -1 ?
          $router.push({
            name: `${location}WorkPackageWorkStepsDetails`,
            params: {
              content_id: workstep_link.value,
              nav_back: $route.params.nav_back,
            }
          }) : ''" style="width: 100%;" />
      </template>

      <!-- Offset -->
      <DisableableInputField v-if="!['Work', 'Material', 'Machine'].includes(step_type)" class="mt-2 mb-2"
        :label="$t('WorkpackageRework.Steps.Offset') + '[' + $t('WorkpackageRework.Steps.TaktTimes') + ']'"
        input_type="number" unit="TT" :value="step.offset"
        :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id })"
        :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
        @change="updateStepValue(step_type, step.id, 'offset', parseInt($event))" />

      <!-- Machine Step Values -->
      <template v-if="step_type === 'Machine'">
        <!-- value -->
        <DisableableInputField class="mt-2 mb-2" label="Booking Value" input_type="number" :value="step.booking_value"
          :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id })"
          :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex" @change="is_create ?
          new_step.booking_value = parseInt($event)
          :
          requestSnackbarUpdate({
            url: [
              { projects: project_id },
              { trains: train_id },
              { taktareas: taktarea_id },
              { twaggons: twaggon_id },
              { tworkpackages: workpackage_id },
              { [`tmachinesteps`]: step.id },
            ],
            update: {
              booking_value: parseInt($event)
            },
            selector: 'parent',
            limit_selector: true
          }).then((payload) => {
            updateUObject(payload);
          })" />
        <!-- unit -->
        <DropDownOutlinedFlat label="Booking Unit" :options="booking_units"
          :value="{ value: step.booking_unit, text: step.booking_unit }"
          :is_disabled="!(isEditMode || is_create) || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id })"
          :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex" width="300" @change="is_create ?
          new_step.booking_unit = $event
          :
          requestSnackbarUpdate({
            url: [
              { projects: project_id },
              { trains: train_id },
              { taktareas: taktarea_id },
              { twaggons: twaggon_id },
              { tworkpackages: workpackage_id },
              { [`tmachinesteps`]: step.id },
            ],
            update: {
              booking_unit: $event
            },
            selector: 'parent',
            limit_selector: true
          }).then((payload) => {
            updateUObject(payload);
          })" />
        <!-- type -->
        <DropDownOutlinedFlat label="Type" :options="machinestep_types" :value="{ value: step.type, text: step.type }"
          :is_disabled="!(isEditMode || is_create) || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: `${step_type} Steps`, twp: workpackage.id })"
          width="300" :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex" @change="is_create ?
          new_step.type = $event
          :
          requestSnackbarUpdate({
            url: [
              { projects: project_id },
              { trains: train_id },
              { taktareas: taktarea_id },
              { twaggons: twaggon_id },
              { tworkpackages: workpackage_id },
              { [`tmachinesteps`]: step.id },
            ],
            update: {
              type: $event
            },
            selector: 'parent',
            limit_selector: true
          }).then((payload) => {
            updateUObject(payload);
          })" />
      </template>

      <!-- Elements -->
      <CollapsableCategory
        v-if="!is_create && ['Work', 'Material'].includes(step_type) && !location.includes('HistProjectTaktPlan')"
        class="mt-2"
        :description="`Elements (${step_type === 'Work' ? (step.elements ? step.elements.length : 0) : (step[`${prefix}worksteps`].length !== 0 ? $store.state.Ultra[`${prefix}worksteps`][step[`${prefix}worksteps`][0]].elements.length : 0)})`"
        :color="workpackage_fg_hex">
        <template #header-middle="{ is_collapsed }">
          <template v-if="is_collapsed && !['absolute', 'none'].includes(step.mass_relation)">
            <div class=" mr-3 step-elements-total-value">{{ calcStepTotal(step, step_type, false, prefix).total_mass }}
              {{ getMassRelationUnit(step.mass_relation) }}</div>
            <div class="step-elements-total-value">{{ calcStepTotal(step, step_type, false, prefix).value }}
              {{ calcStepTotal(step, step_type, false, prefix).unit }}</div>
          </template>
          <!-- LINK Element -->
          <TTooltip v-if="!['Material'].includes(step_type)" :value="getProjectTooltip({ project_id: project_id, action: 'Add', entity: `Elements`, twp: workpackage.id })">
            <v-btn
              icon
              :color="workpackage_fg_hex"
              :disabled="!hasProjectPermissionForTWP({ project_id: project_id, action: 'Add', entity: `Elements`, twp: workpackage.id })"
              @click.stop="$router.push({
                name: `${location}${step_type}StepWorkPackageAvailableElements`,
                params: {
                  nav_back: `${location}WorkPackage${step_type}StepsDetails`,
                }
              })"
            >
              <TIcon name="link" />
            </v-btn>
          </TTooltip>
          <!-- ADD Element -->
          <TTooltip v-if="!['Material'].includes(step_type)" :value="getProjectTooltip({ project_id: project_id, action: 'Add', entity: `Elements`, twp: workpackage.id })">
            <v-btn
              icon
              :color="workpackage_fg_hex"
              :disabled="!hasProjectPermissionForTWP({ project_id: project_id, action: 'Add', entity: `Elements`, twp: workpackage.id })"
              @click.stop="$router.push({
                name: `${location}${step_type}StepWorkPackageElementsDetails`,
                params: {
                  element_id: 'create',
                  nav_back: `${location}WorkPackage${step_type}StepsDetails`,
                }
              })"
            >
              <TIcon name="sign-plus" />
            </v-btn>
          </TTooltip>


          <!-- ToDo: korrekte Implementierung prüfen, z.B. hinsichtlich v-if Tooltip und disabled -->
          <!-- Show Elements with multiWindow -->
          <!-- <TTooltip v-if="!['Material'].includes(step_type)" :value="getProjectTooltip({ project_id: project_id, action: 'Add', entity: `Elements`, twp: workpackage.id })"> -->
          <TTooltip v-if="!['Material'].includes(step_type) && !$vuetify.breakpoint.smAndDown && !$store.state.View.isMobile" value='Show Elements with multiWindow (CTRL+click to force reopen)'>
            <v-btn
              icon
              :color="workpackage_fg_hex"
              :disabled="false"
              @click.stop="openMultiWindow($event)"
            >
              <TIcon name="window-new"/> 
            </v-btn>
          </TTooltip>


        </template>
        <template #content="{ is_collapsed }">
          <template v-if="!is_collapsed">
            <template
              v-if="(step_type === 'Work' && step.elements.length !== 0) || (step_type === 'Material' && step[`${prefix}worksteps`].length !== 0 && $store.state.Ultra[`${prefix}worksteps`][step[`${prefix}worksteps`][0]].elements.length !== 0)">
              <div class="mb-2 d-flex step-elements-calculation" :style="`color: ${workpackage_fg_hex}`">
                <div v-if="step_type === 'Work'">{{ step.performance_value }}
                  mh/{{ getMassRelationUnit(step.mass_relation) }}</div>
                <div v-else-if="step_type === 'Material'">{{ step.conversion_factor }}
                  {{ step.conversion_unit }}/{{ getMassRelationUnit(step.mass_relation) }}</div>
                <div class="step-elements-calculation-operator">*</div>
                <div class="step-elements-total-value">{{ calcStepTotal(step, step_type, false, prefix).total_mass }}
                  {{ getMassRelationUnit(step.mass_relation) }}</div>
                <div class="step-elements-calculation-operator">=</div>
                <div class="step-elements-total-value">{{ calcStepTotal(step, step_type, false, prefix).value }}
                  {{ calcStepTotal(step, step_type, false, prefix).unit }}</div>
              </div>
              <div
                v-for="element_wrapper in getChildElements({ parent_type: `${prefix}worksteps`, parent_id: step_type === 'Work' ? step.id : step[`${prefix}worksteps`][0] })"
                :key="element_wrapper.ifc_type">
                <div class="step-elements-wrapper" :style="`color: ${workpackage_fg_hex}`">
                  <div class="d-flex justify-space-between mt-2 mb-2 cursor-pointer"
                    @click="handleElementWrapperClick(element_wrapper.ifc_type)">
                    <div class="d-flex align-center">
                      <TIcon
                        :style="element_wrappers_open.includes(element_wrapper.ifc_type)? 'transform: rotate(90deg);' : ''"
                        name="chevron-right"
                        :color="workpackage_fg_hex" small />
                      <TIcon :name="getIFCElementIconByName(element_wrapper.ifc_type)"/>
                      <div>{{ element_wrapper.ifc_type }}s ({{ element_wrapper.elements.length }})</div>
                    </div>
                    <div class="d-flex">
                      <div class="mr-3 step-elements-total-value">{{
                        calcStepTotal(step, step_type,
                          element_wrapper.element_ids, prefix).total_mass
                      }} {{ getMassRelationUnit(step.mass_relation) }}
                      </div>
                      <div class="step-elements-total-value" v-if="step.mass_relation !== 'none'">
                        {{ calcStepTotal(step, step_type, element_wrapper.element_ids, prefix).value }} {{ calcStepTotal(step, step_type, element_wrapper.element_ids, prefix).unit }}
                      </div>
                    </div>
                  </div>
                  <template v-if="element_wrappers_open.includes(element_wrapper.ifc_type)">
                    <div class="d-flex justify-space-between" style="margin-left: 16px"
                      v-for="(element, index) in element_wrapper.elements" :key="element.id">
                      <div class="cursor-pointer" @click="$router.push({
                        name: `${location}${step_type}StepWorkPackageElementsDetails`,
                        params: {
                          element_id: element.id,
                          nav_back: `${location}WorkPackage${step_type}StepsDetails`,
                        }
                      })">{{ element.name !== ' ' ? element.name : `${element_wrapper.ifc_type.toLowerCase()} ${index + 1}` }}
                      </div>
                      <div class="d-flex">
                        <div class="mr-3 step-elements-total-value-noborder">{{
                          calcStepTotal(step, step_type,
                            [element.id], prefix).total_mass
                        }} {{ getMassRelationUnit(step.mass_relation) }}</div>
                        <div class="step-elements-total-value-noborder" v-if="step.mass_relation !== 'none'">
                          {{ calcStepTotal(step, step_type, [element.id], prefix).value }} {{
                            calcStepTotal(step,
                              step_type, [element.id], prefix).unit
                          }}</div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            <div v-else>
              <div :style="`color: ${workpackage_fg_hex}`">No Elements Linked</div>
            </div>
          </template>
        </template>
      </CollapsableCategory>

      <!-- Materials -->
      <template v-if="!is_create && ['Material'].includes(step_type) && !location.includes('HistProjectTaktPlan') && !isWbWorkpackage">
        <CollapsableCategory class="mt-2" :description="`Materials (${tmaterials.length})`" :color="workpackage_fg_hex">
          <template #header-middle>
          <!-- ADD Material -->
          <!-- getProjectTooltip({ project_id: project_id, action: 'Add', entity: `Materials`, twp: workpackage.id }) -->
          <!-- :disabled="!hasProjectPermissionForTWP({ project_id: project_id, action: 'Add', entity: `Elements`, twp: workpackage.id })" -->
          <TTooltip value="Add Materials">
            <v-btn
              icon
              :color="workpackage_fg_hex"
              @click.stop="
              hasBusiness ?
                $router.push({ name: 'TaktPlanWorkPackageMaterialStepMaterials', params: { template_type: 'company', nav_back: $route.params.nav_back, } }) :
                $router.push({ name: 'TaktPlanWorkPackageMaterialStepMaterials', params: { template_type: 'custom', nav_back: $route.params.nav_back, } })
              "
            >
              <TIcon name="sign-plus" />
            </v-btn>
          </TTooltip>
        </template>

          <template #content="{ is_collapsed }">
            <template v-if="!is_collapsed">
              <template v-if="(step_type === 'Material')">
                <ClickableListItem v-for="material in tmaterials" :key="material['Name (en)']" :id="material.id"
                  :is_selected="material.id === selected_id" :margin="2" :is_completely_clickable="true" @click.native="$router.push({
                    name: 'TaktPlanWorkPackageMaterialStepMaterialEditor',
                    params: {
                      template_type: 'project',
                      material_id: material.id,
                      nav_back: $route.params.nav_back,
                    }
                  })">
                  <template #descriptor>
                    <StepDescriptor :step_name="material.name" :background_color="workpackage_bg_hex"
                      :foreground_color="workpackage_fg_hex" />
                  </template>
                  <template #info>
                    <div v-if="!['Work', 'Material'].includes(step_type)" style="white-space: nowrap;">
                      {{ step.offset }} TT
                    </div>
                    <TIconButton
                      v-if="['Material'].includes(step_type)"
                      icon="bin-delete"
                      tooltip="Delete Material"
                      :disabled="!isEditMode"
                      :color="workpackage_fg_hex"
                      @clickIcon="
                        deleteUObject({
                          url: [
                            { projects: $route.params.project_id },
                            { trains: $route.params.train_id },
                            { taktareas: $route.params.taktarea_id },
                            { twaggons: $route.params.twaggon_id },
                            { tworkpackages: $route.params.tworkpackage_id },
                            { tmaterialsteps: $route.params.content_id },
                            { tmaterials: material.id },
                          ],
                        })
                        "
                      />
                  </template>
                </ClickableListItem>
              </template>
              <div v-else>
                <div :style="`color: ${workpackage_fg_hex}`">No material found</div>
              </div>
            </template>
          </template>
        </CollapsableCategory>
      </template>
      <template v-if="!is_create && ['Material'].includes(step_type) && !location.includes('HistProjectTaktPlan') && isWbWorkpackage">
        <TText
          value="Workable Backlog does not support Materials"
          size="12"
          :font_weight="400"
        />
      </template>

      <!-- IMAGE TILES -->
      <!-- Description is hard coded, is always sorted by latest, is always tiles -->
      <WorkPackageImageGalleryListModule v-if="!location.includes('HistProjectTaktPlan')"
        :description="`Images (${step[`${prefix}workpackageimages`] ? step[`${prefix}workpackageimages`].length : '0'})`"
        :categorized_images="workstep_images" 
        sort_by="Latest" 
        layout="tiles"
        :init_expanded="step[`${prefix}workpackageimages`] && step[`${prefix}workpackageimages`].length > 0 ? true : false"
        :background_color="workpackage_bg_hex" 
        :foreground_color="workpackage_fg_hex"
        @emittedClick="$router.push({ name: `${location}${step_type}StepWorkPackageImagesDetails`, params: { image_id: $event.id, nav_back: $route.params.nav_back } })"
      >
        <template #header-middle>
          <!-- ADD IMAGE -->
          <TTooltip value="Images">
            <v-btn
              icon
              :color="workpackage_fg_hex"
              @click.stop="$router.push({
                name: `${location}${step_type}StepWorkPackageImagesDetails`,
                params: {
                  image_id: 'create',
                  nav_back: `${location}WorkPackage${step_type}StepsDetails`,
                  prefix: 't'
                }
              })"
            >
              <TIcon :color="workpackage_fg_hex" name="sign-plus" />
            </v-btn>
          </TTooltip>
        </template>
      </WorkPackageImageGalleryListModule>

      <CollapsableCategory v-if="location == 'ProjectWallet'" :description="`Substeps (${step.substeps.length})`" :color="workpackage_fg_hex">
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed" class="work-package-step-detail-microlevel-list">
              <!-- CREATE NEW SUBSTEPS -->
              <div class="work-package-step-detail-microlevel-container">
                <!-- DAY PICKER -->
                <DropDownOutlinedFlatComponent
                  :background_color="workpackage_bg_hex"
                  :foreground_color="workpackage_fg_hex"
                  width="60"
                  height="48"
                  :options="getWorkingDays({takt_index: $route.params.takt_index, project_id: project_id})"
                  :value="new_substep.day_index"
                  @change="new_substep.day_index = parseInt($event)"
                />  
                
                <!-- GRID PICKER -->
                <DropDownOutlinedFlatComponent
                  v-if="isShowMicroGrid"
                  class="work-package-step-detail-flex-grow"
                  :background_color="workpackage_bg_hex"
                  :foreground_color="workpackage_fg_hex"
                  height="48"
                  :options="grid_sections"
                  :value="getWorkingDays({ takt_index: $route.params.takt_index, project_id: project_id })[new_substep.grid_index]"
                  @change="new_substep.grid_index = $event"
                />  

                <!-- TIME PICKER -->
                <StandardTimePicker 
                  v-else 
                  :color="workpackage_fg_hex"
                  :time_range="{ start: new_substep.start, duration: new_substep.duration }"
                  :limit_time_range="{ start: $store.state.Ultra.projects[project_id].working_time_start, duration: $store.state.Ultra.projects[project_id].working_time_duration }"
                  @change="Object.assign(new_substep, $event)"
                />

                <!-- RIGHT SIDE-->
                <div class="work-package-step-detail-microlevel-right-side">
                  <!-- GRID TOGGLE -->
                  <ButtonOutlined 
                    :color="workpackage_fg_hex"
                    padding="0 8px"
                    height="48"
                    @buttonClicked="setValue({ key: 'isShowMicroGrid', value: !isShowMicroGrid })"
                  >
                    <template #text>
                      <RadialCheckbox
                        :is_checked="isShowMicroGrid"
                        :foreground_color="workpackage_fg_hex"
                      />
                      <TText
                        value="Show Grid"
                        :color="workpackage_fg_hex"
                        font_weight="400"
                      />
                    </template>
                  </ButtonOutlined>

                  <!-- ADD BUTTON -->
                  <TIconButton 
                    icon="sign-plus" 
                    :color="workpackage_fg_hex"
                    tooltip="Add to grid"
                    size="48"
                    @clickIcon="addSubstep()"
                  />
                </div>
              </div>

              <div class="work-package-step-detail-microlevel-line" :style="`border-color: ${getTranspHexColor(getColor(workpackage_fg_hex), 0.33)};`"/>

              <!-- CREATED SUBSTEPS -->
              <div 
                class="work-package-step-detail-microlevel-container"
                v-for="substep_id in substeps_filtered" 
                :key="substep_id"
              >
                <!-- DAY PICKER -->
                <DropDownOutlinedFlatComponent
                  :background_color="workpackage_bg_hex"
                  :foreground_color="workpackage_fg_hex"
                  width="60"
                  height="48"
                  :options="getWorkingDays({takt_index: $route.params.takt_index, project_id: project_id})"
                  :value="getWorkingDays({takt_index: $route.params.takt_index, project_id: project_id})[getUObject({id: substep_id, type: 'substeps'}).day_index]"
                  @change="
                    requestSnackbarUpdate({
                      url: [
                        { projects: project_id },
                        { trains: train_id },
                        { taktareas: taktarea_id },
                        { twaggons: twaggon_id },
                        { tworkpackages: workpackage_id },
                        { [`t${step_type.toLowerCase()}steps`]: step.id },
                        {substeps: substep_id}
                      ],
                      update: { day_index : parseInt($event)}
                    }).then((payload) => {
                      updateUObject(payload)
                    })"
                />

                <!-- TIME PICKER -->
                <StandardTimePicker
                  :color="workpackage_fg_hex"
                  :time_range="{start: getUObject({id: substep_id, type: 'substeps'}).start, duration: getUObject({id: substep_id, type: 'substeps'}).duration}"
                  :limit_time_range="{start: $store.state.Ultra.projects[project_id].working_time_start, duration: $store.state.Ultra.projects[project_id].working_time_duration}"
                  @change="
                  requestSnackbarUpdate({
                      url: [
                        { projects: project_id },
                        { trains: train_id },
                        { taktareas: taktarea_id },
                        { twaggons: twaggon_id },
                        { tworkpackages: workpackage_id },
                        { [`t${step_type.toLowerCase()}steps`]: step.id },
                        {substeps: substep_id}
                      ],
                      update: { start: $event.start, duration: $event.duration}
                    }).then((payload) => {
                      updateUObject(payload)
                    })"
                />

                <!-- RIGHT SIDE -->
                <div class="work-package-step-detail-microlevel-right-side">
                  <!-- NOTE: this button is not being shown but necessary for proper indentation -->
                  <ButtonOutlined 
                    style="visibility: hidden;"
                    padding="0 8px"
                    height="48"
                  >
                    <template #text>
                      <RadialCheckbox/>
                      <TText
                        value="Show Grid"
                        font_weight="400"
                      />
                    </template>
                  </ButtonOutlined>

                  <!-- DELETE BUTTON -->
                  <TIconButton 
                    icon="bin" 
                    :color="workpackage_fg_hex"
                    tooltip="Remove from grid"
                    size="48"
                    @clickIcon="
                      requestSnackbarDelete({
                        url: [
                        { projects: project_id },
                        { trains: train_id },
                        { taktareas: taktarea_id },
                        { twaggons: twaggon_id },
                        { tworkpackages: workpackage_id },
                        { [`t${step_type.toLowerCase()}steps`]: step.id },
                        { substeps: substep_id },
                      ]
                      }).then((payload) => {
                        deleteUObject(payload)
                      })
                    "
                  />
                </div>
              </div>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    </template>
  </WorkPackageSubPageModule>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';

import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
import ModularEquation from '@/modules/WorkPackageWIP/ModularEquation.module.vue';
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';

import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';

import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import StepDescriptor from '@/modules/WorkPackageWIP/StepDescriptor.module.vue';
import WorkPackageImageGalleryListModule from '@/modules/WorkPackageWIP/WorkPackageImageGalleryListModule.module.vue';

import TIcon from '@/components/Taktify/TIcon.component.vue';

import TText from '@/components/Taktify/TText.component.vue';
import StandardTimePicker from '@/components/StandardComponents/StandardTimePicker.component.vue'
import DropDownOutlinedFlatComponent from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
import TIconButton from '@/components/Taktify/TIconButton.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

import { MultiWindowMixin } from '@/mixins/MultiWindow.mixin.js';


export default {
  props: ['location', 'step_type', 'step_card', 'backlog', 'prefix'],

    components: {
      RadialCheckbox,
      TextArea,
      ModularEquation,
      WorkPackageSubPageModule,
      LabelOutlined,
      ButtonOutlined,
      WorkPackageImageGalleryListModule,
      DisableableInputField,
      DropDownOutlinedFlat,
      CollapsableCategory,
      ClickableListItem,
      StepDescriptor,
      StandardDialogFullScreen,
      TIcon,
      TText,
      StandardTimePicker,
      DropDownOutlinedFlatComponent,
      TIconButton,
      TransitionAccordion,
    },

  mixins: [
    WorkPackageReworkMixin,
    TColor,
    MultiWindowMixin,
  ],

  data: () => ({
    new_step: {
      id: -1,
      text: '',
      done: false,
      performance_value: 0,
      mass_relation: 'absolute',
      conversion_factor: 0,
      conversion_unit: 'none',
      offset: 0,
      tworksteps: [],
      tmaterialsteps: [],
      ['add#tworksteps']: [],
      ['add#tmaterialsteps']: [],
      wbworksteps: [],
      wbmaterialsteps: [],
      ['add#wbworksteps']: [],
      ['add#wbmaterialsteps']: [],
    },
    selected_id: -1,
    element_wrappers_open: [],
    activated_material_id: -1,
    new_substep: {
      start: 0,
      duration: 0,
      grid_index: 0,
      day_index: 0
    },
  }),

  created() {
    if (this.step_card) {
      this.loadStepCardStep();
    } else if (!this.is_create) {
      // this.requestMaterials(this.step.text);
      if (!this.location.includes('HistProjectTaktPlan')) {
        this.loadData();
      }
    }
    this.new_substep.start = this.$store.state.Ultra.projects[this.project_id].working_time_start
    this.new_substep.duration = this.$store.state.Ultra.projects[this.project_id].working_time_duration
  },

  watch: {
    workpackage_id() {
      this.$router.push({ name: `${this.location}WorkPackage${this.step_type}Steps`, params: { nav_back: this.$route.params.nav_back } })
    },
    step_id() {
      if (this.step_card) {
        this.loadStepCardStep();
      }
      if (!this.is_create) {
        // this.requestMaterials(this.step.text);
        if (!this.location.includes('HistProjectTaktPlan')) {
          this.loadData();
        }
      }
    }
  },

    computed: {
      ...mapGetters('ProjectStructure', [
        'getChildElements'
      ]),
      ...mapGetters('Material', [
        'getMaterial',
      ]),
      ...mapGetters('Auth', [
        'hasPermission',
        'hasBusiness'
      ]),
      ...mapGetters('Project', [
        'hasProjectPermissionForTWP',
      ]),
      ...mapState('Ultra', [
        'booking_units',
        'machinestep_types'
      ]),
      ...mapGetters('Ultra', [
        'getIFCElementIconByName',
      ]),
      ...mapGetters('WorkPackageImage', [
        'getWorkPackageImagesSorted'
      ]),
      ...mapGetters('ProjectCalendar', [
        'getCalendar',
        'getWorkingDays',
        'getGridSections'
      ]),
      ...mapState('View', [
        'isShowMicroGrid'
      ]),
    // mapState('Ultra' {
    //   step: state => state[`t${this.step_type.toLowerCase()}steps`][this.$route.params.content_id];
    // })

    step_id() {
      if (this.step_card) {
        return this.$route.params[`${this.step_type.toLowerCase()}_card_id`];
      } else {
        return this.$route.params.content_id;
      }
    },

    step() {
      if (this.is_create) {
        return this.new_step;
      } else if (this.$store.state.Ultra[`${this.histprefix}${this.prefix}${this.step_type.toLowerCase()}steps`][this.step_id]) {
        return this.$store.state.Ultra[`${this.histprefix}${this.prefix}${this.step_type.toLowerCase()}steps`][this.step_id];
      } else {
        return {
          id: -1,
          text: '',
          performance_value: 0,
          conversion_factor: 0,
          mass_relation: '',
          tmaterials: [],
          [`${this.prefix}worksteps`]: []
        };
      }
    },
    tmaterials() {
      return this.getUObjects({ type: 'tmaterials', ids: this.step.tmaterials });
    },
    workstep_link() {
      if (this.location.includes('HistProjectTaktPlan') || this.step.id === -1 || this.step[`${this.prefix}worksteps`].length === 0) {
        return { text: 'No WORK.step Link', value: -1 }
      } else {
        let workstep = this.$store.state.Ultra[`${this.prefix}worksteps`][this.step[`${this.prefix}worksteps`][0]];
        return { text: workstep.text, value: workstep.id }
      }
    },

    workstep_link_selection() {
      let selection = [{ text: 'No WORK.step Link', value: -1 }];

      if (!this.location.includes('HistProjectTaktPlan')) {
        if (this.workpackage[`${this.prefix}worksteps`].length !== 0) {
          selection = selection.concat(this.workpackage[`${this.prefix}worksteps`].map(id => {
            return { text: this.$store.state.Ultra[`${this.prefix}worksteps`][id].text, value: id };
          }));
        } else if (this.step[`${this.prefix}worksteps`].length !== 0) {
          let id = this.step[`${this.prefix}worksteps`][0];
          selection.push({ text: this.$store.state.Ultra[`${this.prefix}worksteps`][id].text, value: id });
        }
      }
      return selection;
    },

    workstep_images() {
      // TODO: update store to delete properly!
      if (!this.location.includes('HistProjectTaktPlan') && this.step[`${this.prefix}workpackageimages`]) {
        return this.getWorkPackageImagesSorted({ workpackage: { [`${this.prefix}workpackageimages`]: this.step[`${this.prefix}workpackageimages`] }, prefix: this.prefix });
      } else {
        return {};
      }
    },

    grid_sections() {
      // console.log(this.getGridSections(this.project_id));
      let grid_sections = this.getGridSections(this.project_id);
      if (!grid_sections.length) {
        return [{
          value: 0, 
          text: this.convertSecondsToTime(this.$store.state.Ultra.projects[this.project_id].working_time_start) + ' - ' + this.convertSecondsToTime(this.$store.state.Ultra.projects[this.project_id].working_time_start + this.$store.state.Ultra.projects[this.project_id].working_time_duration), 
          start: this.$store.state.Ultra.projects[this.project_id].working_time_start,
          duration: this.$store.state.Ultra.projects[this.project_id].working_time_duration
        }]
      }
      let grid = [];
      grid_sections.forEach((section, index) => {
        grid.push({
          value: index, 
          text: this.convertSecondsToTime(section.start) + ' - ' + this.convertSecondsToTime(section.start + section.duration),
          start: section.start,
          duration: section.duration
        })
      });
      return grid;
    },
    substeps_filtered() {
      let substeps = this.step.substeps
      substeps = substeps.map((step_id) => this.getUObject({type: 'substeps', id: step_id}))
      substeps.sort(function(a,b){
        if(a.day_index< b.day_index) return -1;
        if(a.day_index >b.day_index) return 1;
        if(a.start< b.start) return -1;
        if(a.start >b.start) return 1;
        return 0;
      });
      return substeps.map((step) => step.id)
    },
    isWbWorkpackage() {
      return this.backlog;
    },
  },

  methods: {
    addSubstep() {
      // console.log(this.new_substep)
      let substep = {}
      if (this.isShowMicroGrid) {
        let section = this.grid_sections[this.new_substep.grid_index]
        substep.start = section.start;
        substep.duration = section.duration;
        substep.day_index = this.new_substep.day_index;
      } else {
        substep.start = this.new_substep.start;
        substep.duration = this.new_substep.duration;
        substep.day_index = this.new_substep.day_index;
      }
      // this.requestSnackbar({
      //   url: [
      //     { projects: this.project_id },
      //     { trains: this.train_id },
      //     { taktareas: this.taktarea_id },
      //     { twaggons: this.twaggon_id },
      //     { tworkpackages: this.workpackage_id },
      //     { [`t${this.step_type.toLowerCase()}steps`]: this.step.id },
      //     { substeps: ''},
      //     {showWithEntitiesNormalized: ''},
      //   ],
      //   u_object: substep,
      // }).then((payload) => {
      //   this.createUObject(payload)
      // })
      this.requestSnackbarCreate({
        url: [
          { projects: this.project_id },
          { trains: this.train_id },
          { taktareas: this.taktarea_id },
          { twaggons: this.twaggon_id },
          { tworkpackages: this.workpackage_id },
          { [`t${this.step_type.toLowerCase()}steps`]: this.step.id },
          { substeps: ''},
          {showWithEntitiesNormalized: ''},
        ],
        u_object: substep,
      }).then((payload) => {
        this.createUObject(payload)
      })
      // this.createUObject({
      //     url: [
      //         { projects: this.project_id },
      //         { trains: this.train_id },
      //         { taktareas: this.taktarea_id },
      //         { twaggons: this.twaggon_id },
      //         { tworkpackages: this.workpackage_id },
      //         { [`t${this.step_type.toLowerCase()}steps`]: this.step.id },
      //         { substeps: ''},
      //         {showWithEntitiesNormalized: ''},
      //       ],
      //       u_object: substep,
      //       // resp_data: {
      //       //   substeps: [
      //       //     substep
      //       //   ]
      //       // }
      //     });
      //   // console.log(this.$store.state.Ultra)
    },
    convertSecondsToTime(seconds) {
        return new Date(seconds * 1000).toISOString().slice(11, 16);
    },
    convertTimeToSeconds(arr, i, seconds, time_index) {
      if(arr.length === i){
        return seconds;
      } else {
        seconds += arr[arr.length - i - 1] * Math.pow(60, time_index)
        return this.convertTimeToSeconds(arr, ++i, seconds, ++time_index)
      }
    },
    test() {
      // console.log('test')
      // console.log(this.$store.state.Ultra)
      // console.log(this.new_substep, this.getGridSections(this.project_id))
      // console.log(this.getWorkingDays({takt_index: this.$route.params.takt_index, project_id: this.project_id}))
    },
    ...mapActions('Ultra', [
      'updateUObject',
      'updateUObjectRelations',
    ]),
    ...mapActions('UltraDev', [
      'updateUDObject',
      'createUDObject',
      'deleteUDObject'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarUpdate',
      'requestSnackbarDelete',
      'requestSnackbarCreate',
    ]),
    ...mapActions('ProjectWallet', [
      'updateStepCardStatus',
      'increaseUpdateKeyStepCard',
    ]),
    ...mapActions('View', [
      'setValue'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbar',
      'requestSnackbarCreate',
      'requestSnackbarUpdate',
      'requestSnackbarUpdatePosition',
      'requestSnackbarDelete',
      'updateSnackbar'
    ]),
    // ...mapActions('Material', [
    //   'requestMaterials',
    // ]),
    updateStepValue(step_type, step_id, key, value) {
      if (this.is_create) {
        this.new_step[key] = value
      } else if (this.backlog) {
        this.updateUObject({
          url: this.getStepUrl(step_type, step_id),
          update: {
            [key]: value
          }
        })
      } else {
        this.requestSnackbarUpdate({
          url: this.getStepUrl(step_type, step_id),
          update: {
            [key]: value
          },
          selector: 'parent',
          limit_selector: true
        }).then((payload) => {
          this.updateUObject(payload);
        })
      }
    },
    loadData() {
      this.$store.dispatch('Ultra/requestUObject', {
        url: this.getStepUrl(this.step_type, this.step_id).concat([{ showWithEntitiesNormalized: '' }]),
        add_u_object: false
      }).then(() => {
        this.updateUDObject({
          url: this.getStepUrl(this.step_type, this.step_id),
          update: {
            loaded_from_backend: true
          }
        })
      })
    },

    loadSteps() {
      this.$store.dispatch('Ultra/requestUObject', {
        url: this.getStepUrl('work', '').concat([{ showWithEntitiesNormalized: '' }]),
        add_u_object: true
      });
    },

    loadStepCardStep() {
      this.$store.dispatch('Ultra/requestUObject', {
        url: [
          { projects: this.project_id },
          { trains: this.train_id },
          { taktareas: this.taktarea_id },
          { twaggons: this.twaggon_id },
          { tworkpackages: this.workpackage_id },
          { [`t${this.step_type.toLowerCase()}steps`]: this.step_id },
          { showWithEntitiesNormalized: '' }
        ]
      })
      if(this.location == 'ProjectWallet'){
      // TODO BUG Backend 500er
      // console.log(this.step_type.toLowerCase())
      //   this.$store.dispatch('Ultra/requestUObject', {
      //   url: [
      //     { projects: this.project_id },
      //     { trains: this.train_id },
      //     { taktareas: this.taktarea_id },
      //     { twaggons: this.twaggon_id },
      //     { tworkpackages: this.workpackage_id },
      //     { [`t${this.step_type.toLowerCase()}steps`]: this.step_id },
      //     { substeps: ''},
      //     { showWithEntitiesNormalized: '' }
      //   ]
      // })
      this.$store.dispatch('Ultra/requestUObject', {
        url: [
          { projects: this.project_id },
          { gridsections: ''},
          { showWithEntitiesNormalized: '' }
        ]
      })
      }
    },

    changeWorkStepLink(evt) {
      let old_step_id = JSON.parse(JSON.stringify(this.workstep_link.value));
      if (this.is_create) {
        if (evt !== -1) {
          this.step[`${this.prefix}worksteps`].push(evt);
          this.step[`add#${this.prefix}worksteps`].push(evt);
        }
        if (old_step_id !== -1) {
          let index = this.step[`${this.prefix}worksteps`].indexOf(old_step_id);
          this.step[`${this.prefix}worksteps`].splice(index, 1);
        }
      } else {
        let promises = [];
        if (old_step_id !== -1) {
          promises.push(
            this.updateUObjectRelations({
              url: this.getStepUrl('material', this.step.id),
              target_type: `${this.prefix}worksteps`,
              target_ids: [old_step_id],
              action: 'remove',
              bidirectional: true,
              // local: true,
            })
          );
        }
        Promise.all(promises).then(() => {
          if (evt !== -1) {
            this.updateUObjectRelations({
              url: this.getStepUrl('material', this.step.id),
              target_type: `${this.prefix}worksteps`,
              target_ids: [evt],
              action: 'add',
              bidirectional: true,
              // local: true,
            })
          }
        })
      }
    },

    handleElementWrapperClick(element_wrapper) {
      let index = this.element_wrappers_open.indexOf(element_wrapper);
      if (index === -1) {
        this.element_wrappers_open.push(element_wrapper);
      } else {
        this.element_wrappers_open.splice(index, 1);
      }
    },
    getStepUrl(step_type, step_id) {
      let url;
      if (this.backlog) {
        url = [
          { projects: this.project_id },
          { [`${this.histprefix}wbgroups`]: this.wbgroup_id },
          { [`${this.histprefix}wblines`]: this.wbline_id },
          { [`${this.histprefix}wbworkpackages`]: this.workpackage_id },
          { [`${this.histprefix}${this.prefix}${step_type.toLowerCase()}steps`]: step_id },
        ]
      } else {
        url = [
          { projects: this.project_id },
          { [`${this.histprefix}trains`]: this.train_id },
          { [`${this.histprefix}taktareas`]: this.taktarea_id },
          { [`${this.histprefix}twaggons`]: this.twaggon_id },
          { [`${this.histprefix}tworkpackages`]: this.workpackage_id },
          { [`${this.histprefix}${this.prefix}${step_type.toLowerCase()}steps`]: step_id },
        ]
      }
      if (this.location.includes('HistProjectTaktPlan')) {
        url.splice(1, 0, { histprojects: this.$route.params.histproject_id });
      }
      return url;
    },
  }
}
</script>

<style>
.work-package-step-detail-status-container {
  display: flex;
  grid-gap: 8px;
  width: 100%;
}

.work-package-step-detail-flex-grow {
  flex-grow: 1;
}

.step-elements-total-value {
  display: flex;
  justify-content: flex-end;
  border: 1px solid;
  border-radius: 3px;
  padding: 1px;
  width: 60px;
  font-weight: 300;
  font-size: 10pt;
}

.step-elements-total-value-noborder {
  display: flex;
  justify-content: flex-end;
  width: 60px;
  font-weight: 300;
  font-size: 10pt;
}

.step-elements-calculation {
  font-weight: 300;
  font-size: 10pt;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid;
  padding-bottom: 4px;
}

.step-elements-calculation-operator {
  display: flex;
  justify-content: center;
  width: 12px;
}

.step-elements-wrapper {
  font-weight: 300;
  font-size: 12pt;
}

.work-package-step-detail-microlevel-list {
  display: flex; 
  flex-direction: column; 
  grid-gap: 8px;
}

.work-package-step-detail-microlevel-container {
  display: flex; 
  flex-direction: row; 
  align-items: center; 
  justify-content: 
  space-between; 
  grid-gap: 8px;
}

.work-package-step-detail-microlevel-right-side {
  display: flex; 
  align-items: center; 
  grid-gap: 8px;
}

.work-package-step-detail-microlevel-line {
  width: 100%; 
  border-bottom: 1px solid;
}
</style>
